import { AlertTriangle } from "lucide-react";

interface Props {
  attemptedMode: string;
  alternatives: string[];
  onPickAlternative: (mode: string) => void;
}

export function CapabilityMismatchCard({ attemptedMode, alternatives, onPickAlternative }: Props) {
  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 p-3 dark:border-amber-700/40 dark:bg-amber-950/40">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 size-4 text-amber-700 dark:text-amber-300" />
        <div className="flex-1">
          <p className="text-xs font-semibold text-amber-900 dark:text-amber-200">
            Mode '{attemptedMode}' not available on current hardware
          </p>
          {alternatives.length > 0 && (
            <>
              <p className="mt-1 text-[11px] text-amber-800/90 dark:text-amber-300/90">
                Try one of these modes:
              </p>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {alternatives.map((m) => (
                  <button
                    key={m}
                    type="button"
                    onClick={() => onPickAlternative(m)}
                    className="rounded border border-amber-400 bg-white px-2 py-0.5 font-mono text-[11px] font-semibold text-amber-900 hover:bg-amber-100 dark:border-amber-600 dark:bg-amber-900/30 dark:text-amber-200 dark:hover:bg-amber-900/50"
                  >
                    {m}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
